(function () {
  'use strict';
  if (window.FotoMasterLeadEmailOptIn) return;
  var submitted = new WeakSet();

  function submit(signupFormId, choice, result) {
    if (!choice || choice.email_marketing_requested !== true
        || choice.email_marketing_source !== 'form_submission'
        || !['inquiry-email-news-offers-v1', 'inquiry-explicit-opt-in-v2'].includes(choice.email_marketing_consent_version)
        || !result || result.accepted !== true || result.duplicate === true) return false;
    var signupForm = document.getElementById(signupFormId);
    if (!signupForm || typeof signupForm.requestSubmit !== 'function') return false;
    var emailInput = signupForm.querySelector('[name="contact[email]"]');
    if (!emailInput || typeof choice.email !== 'string') return false;
    if (submitted.has(signupForm)) return true;
    emailInput.value = choice.email.trim();
    if (!emailInput.checkValidity()) return false;
    submitted.add(signupForm);
    try {
      signupForm.requestSubmit();
      return true;
    } catch (error) {
      submitted.delete(signupForm);
      return false;
    }
  }

  window.FotoMasterLeadEmailOptIn = {submit: submit};
})();
